export default {
  87: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Menerapkan projek penguatan profil pelajar Pancasila dengan jumlah yang lebih sedikit atau lebih banyak dari yang dianjurkan Kemendikbudristek</li>',
        '<li>Projek berorientasi pada menghasilkan artifak (produk seperti makanan, minuman), belum menitikberatkan pada pemahaman tentang konsep dan/atau penyelesaian masalah (problem solving)</li>',
        '</ul>',
      ].join(''),
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Menerapkan projek penguatan profil pelajar Pancasila dengan jumlah yang lebih sedikit atau lebih banyak dari yang dianjurkan Kemendikbudristek</li>',
        '<li>Projek diawali dengan identifikasi masalah yang dipandu atau diarahkan lebih banyak oleh guru sehingga kegiatan projek mulai berorientasi pada pemahaman tentang konsep dan/atau penyelesaian masalah (problem solving) sesuai tema</li>',
        '</ul>',
      ].join(''),
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Menerapkan projek penguatan profil pelajar Pancasila dengan jumlah yang lebih sedikit atau lebih banyak dari yang dianjurkan Kemendikbudristek</li>',
        '<li>Projek diawali dengan identifikasi masalah yang difasilitasi oleh guru sehingga kegiatan projek mulai berorientasi pada pemahaman tentang konsep dan/atau penyelesaian masalah (problem solving) sesuai tema</li>',
        '</ul>',
      ].join(''),
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Menerapkan projek penguatan profil pelajar Pancasila dengan jumlah yang lebih sedikit atau lebih banyak dari yang dianjurkan Kemendikbudristek</li>',
        '<li>Projek diawali dengan identifikasi masalah yang lebih banyak dilakukan berdasarkan inisiatif siswa dan difasilitasi guru dan/atau mitra komunitas yang terlibat sebagai fasilitator atau narasumber sehingga kegiatan projek berorientasi pada pemahaman tentang konsep dan/atau penyelesaian masalah (problem solving) sesuai tema</li>',
        '</ul>',
      ].join(''),
    },
  ],
  88: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi:
        'Guru menggunakan metode pengajaran yang bervariasi namun masih didominasi oleh peran seperti instruktur yang mengarahkan kegiatan peserta didik sepanjang proses pembelajaran',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Guru menggunakan metode pembelajaran yang bervariasi dan berpusat pada peserta didik, serta metode yang sesuai dengan tujuan pembelajaran',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Guru menggunakan metode pembelajaran yang bervariasi dan berpusat pada peserta didik, serta sesuai dengan tujuan pembelajaran dan kebutuhan peserta didik</li>',
        '<li>Peran sebagai fasilitator lebih dominan, ditunjukkan dengan dengan memberikan lebih banyak kesempatan untuk siswa belajar mandiri, bertanggung jawab atas proses belajar mereka</li>',
        '</ul>',
      ].join(''),
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Guru membedakan metode pembelajaran sesuai dengan kebutuhan, capaian/performa, dan minat siswa</li>',
        '<li>Guru lebih terampil berperan sebagai fasilitator dengan memberikan lebih banyak kesempatan untuk peserta didik belajar mandiri dan bertanggung jawab atas proses belajar mereka</li>',
        '</ul>',
      ].join(''),
    },
  ],
  89: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Guru melakukan asesmen pada awal pembelajaran namun tidak digunakan untuk merancang pembelajaran ataupun untuk mengidentifikasi peserta didik yang membutuhkan perhatian lebih.</li>',
        '<li>Guru mulai melakukan asesmen beberapa kali (tidak hanya saat mendekati masa pelaporan/rapor) namun asesmen dilakukan hanya untuk memberikan nilai kepada siswa dan belum digunakan untuk merancang pembelajaran</li>',
        '<li>Guru hanya menggunakan asesmen yang disediakan dalam buku teks dan/atau modul ajar</li>',
        '</ul>',
      ].join(''),
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Guru melakukan asesmen formatif pada awal pembelajaran dan hasilnya digunakan untuk mengidentifikasi peserta didik yang membutuhkan perhatian lebih Ketika merancang asesmen, guru mulai memperhatikan kesesuaian antara asesmen dengan tujuan pembelajaran.',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Guru melakukan asesmen formatif pada awal pembelajaran dan hasilnya digunakan untuk merancang pembelajaran berikutnya yang sesuai dengan capaian mayoritas peserta didik di kelasnya (belum merupakan rencana pembelajaran terdiferensiasi)</li>',
        '<li>Guru melakukan asesmen untuk mendapatkan umpan balik tentang kebutuhan belajar peserta didik dan menentukan tindak lanjutnya</li>',
        '</ul>',
      ].join(''),
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Guru melakukan asesmen formatif pada awal pembelajaran dan hasilnya digunakan untuk merancang pembelajaran terdiferensiasi sesuai dengan tahap capaian peserta didik (teaching at the right level)</li>',
        '<li>Guru mampu melakukan penyesuaian pembelajaran sepanjang proses pembelajaran agar semua peserta didik mencapai tujuan pembelajaran.</li>',
        '<li>Satuan pendidikan mengembangkan kebijakan yang mendorong guru untuk menggunakan hasil asesmen dalam merancang kurikulum dan pembelajaran.</li>',
        '</ul>',
      ].join(''),
    },
  ],
  90: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi:
        'Berdasarkan asesmen formatif di awal pembelajaran, guru mengajar seluruh siswa di kelasnya sesuai dengan fase Capaian Pembelajaran mayoritas siswa di kelasnya.',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Berdasarkan asesmen formatif di awal pembelajaran, guru mengajar seluruh siswa di kelasnya sesuai dengan fase capaian belajar mayoritas siswa di kelasnya dan dengan memberikan perhatian khusus terhadap sebagian siswa yang membutuhkan perlakuan (materi dan/atau metode belajar) yang berbeda.',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Berdasarkan asesmen formatif di awal pembelajaran, siswa di kelas yang sama dibagi menjadi dua kelompok menurut capaian belajar mereka. Dengan demikian, setiap siswa dapat belajar sesuai dengan capaian belajarnya.</li>',
        '<li>Sekolah menyelenggarakan program pelajaran tambahan untuk siswa yang belum siap untuk belajar sesuai dengan kelasnya.</li>',
        '</ul>',
      ].join(''),
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Berdasarkan asesmen formatif di awal pembelajaran, siswa di kelas yang sama dibagi menjadi dua kelompok menurut capaian belajar mereka. Dengan demikian, setiap siswa dapat belajar sesuai dengan capaian belajarnya.</li>',
        '<li>Sekolah menyelenggarakan berbagai program seperti pelajaran tambahan untuk siswa yang belum siap untuk belajar sesuai dengan kelasnya dan untuk siswa yang membutuhkan pengayaan atau tantangan lebih.</li>',
        '</ul>',
      ].join(''),
    },
  ],
  91: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi:
        'Guru belum berkolaborasi untuk keperluan pembelajaran intrakurikuler, namun sudah berkolaborasi untuk keperluan projek penguatan profil pelajar Pancasila.',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Guru berkolaborasi dalam proses perencanaan pembelajaran di awal atau akhir semester, misalnya diskusi tentang kemajuan belajar peserta didik di akhir semester, berbagi praktik baik, berbagi info tentang perangkat ajar, dsb., dan berkolaborasi untuk keperluan projek penguatan profil pelajar Pancasila.',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi:
        'Guru berkolaborasi dalam perencanaan pembelajaran di awal semester (perencanaan) dan dalam proses pembelajaran sepanjang semester, misalnya melalui diskusi tentang kemajuan belajar peserta didik, berbagi praktik baik, berbagi info tentang perangkat ajar, dsb., dan berkolaborasi untuk keperluan projek penguatan profil pelajar Pancasila serta terlibat dalam evaluasi kurikulum di satuan pendidikan.',
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Guru berkolaborasi untuk perencanaan pembelajaran di awal semester dan dalam proses pembelajaran sepanjang semester, misalnya melalui diskusi tentang kemajuan belajar peserta didik, berbagi praktik baik, berbagi info tentang perangkat ajar, dsb., untuk keperluan projek penguatan profil pelajar Pancasila, dan terlibat dalam pengembangan kurikulum operasional satuan pendidikan.</li>',
        '<li>Satuan pendidikan memiliki kebijakan dan mekanisme yang mendorong kolaborasi guru untuk kegiatan belajar intrakurikuler dan juga projek, misalnya melalui observasi kelas, kegiatan refleksi pembelajaran, kegiatan berbagi praktik baik, dsb.</li>',
        '</ul>',
      ].join(''),
    },
  ],
  92: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Guru melalui satuan pendidikan memberikan informasi tentang kemajuan belajar peserta didik kepada orangtua/wali pada saat penerimaan rapor dan saat peserta didik mengalami masalah belajar</li>',
        '<li>Komunikasi cenderung satu arah, dari pihak satuan pendidikan/ guru kepada orang tua/wali, misalnya guru memberikan saran kepada orangtua/wali tentang apa yang sebaiknya dilakukan untuk mendukung proses belajar peserta didik</li>',
        '</ul>',
      ].join(''),
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Guru berkoordinasi dengan guru lain melalui satuan pendidikan memberikan informasi tentang kemajuan belajar peserta didik kepada orangtua/wali pada saat penerimaan rapor dan secara berkala dalam proses belajar.</li>',
        '<li>Komunikasi cenderung satu arah, dari pihak satuan pendidikan/ guru kepada orang tua/wali, misalnya guru memberikan saran kepada orangtua/wali tentang apa yang sebaiknya dilakukan untuk mendukung proses belajar peserta didik</li>',
        '</ul>',
      ].join(''),
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Guru berkoordinasi dengan guru lain melalui satuan pendidikan memberikan informasi tentang kemajuan belajar peserta didik kepada orangtua/wali pada saat penerimaan rapor dan secara berkala dalam proses belajar.</li>',
        '<li>Komunikasi cenderung dialog dua arah, di mana pihak satuan pendidikan/guru dan orang tua/ wali, mencari ide dan kesepakatan tentang apa yang sebaiknya dilakukan bersama untuk mendukung proses belajar peserta didik</li>',
        '</ul>',
      ].join(''),
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Guru berkomunikasi dengan guru lain melalui satuan pendidikan memberikan informasi tentang kemajuan belajar peserta didik kepada orangtua/wali pada saat penerimaan rapor dan secara berkala dalam proses belajar</li>',
        '<li>Ada saluran komunikasi yang berkala untuk orang tua memberikan umpan balik terhadap kurikulum dan pembelajaran.</li>',
        '<li>Orang tua berkesempatan untuk terlibat dalam pembelajaran, misalnya menjadi narasumber dalam intrakurikuler dan/atau dalam projek penguatan profil pelajar Pancasila</li>',
        '<li>Komunikasi melibatkan tiga pihak, yaitu guru-siswa-orang tua untuk mendiskusikan tahapan belajar dan tindak lanjut yang perlu dilakukan untuk mendukung proses belajar siswa</li>',
        '</ul>',
      ].join(''),
    },
  ],
  93: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi:
        'Satuan pendidikan sudah merancang pelibatan masyarakat/ komunitas/industri dalam proses pembelajaran intrakurikuler maupun projek penguatan profil pelajar Pancasila, namun belum terlaksana.',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Satuan pendidikan melibatkan masyarakat/ komunitas/industri hanya untuk mendukung kegiatan yang tidak berkelanjutan atau kegiatan yang tidak berkaitan dengan pembelajaran intrakurikuler maupun projek penguatan profil pelajar Pancasila.',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi:
        'Satuan pendidikan melibatkan masyarakat/ komunitas/industri untuk mendukung pembelajaran intrakurikuler atau projek penguatan profil pelajar, untuk kegiatan yang lebih panjang jangka waktunya',
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Satuan pendidikan melibatkan masyarakat/ komunitas/industri secara berkelanjutan untuk mendukung pembelajaran intrakurikuler dan projek penguatan profil pelajar Pancasila</li>',
        '<li>Komunitas/industri yang dilibatkan lebih beragam sesuai tujuan pembelajaran intrakurikuler dan projek penguatan profil pelajar Pancasila</li>',
        '</ul>',
      ].join(''),
    },
  ],
  94: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi:
        'Refleksi dan evaluasi implementasi  kurikulum dan pembelajaran cenderung satu arah dari pimpinan  satuan pendidikan, dan belum berbasis data.',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Refleksi dan evaluasi implementasi kurikulum dan pembelajaran dilakukan pembelajaran dilakukan sebagian guru</li>',
        '<li>Refleksi dan evaluasi tersebut belum berbasis data, melainkan  penilaian masing-masing guru berdasarkan pengalaman pribadi dan/atau pandangan rekan sejawat</li>',
        '<li>Sebagian guru menyesuaikan perencanaan pembelajaran berdasarkan hasil refleksi dan evaluasi tersebut</li>',
        '</ul>',
      ].join(''),
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Refleksi dan evaluasi implementasi kurikulum dan pembelajaran dilakukan sebagian guru. Hasil refleksi (pengalaman dan persepsi guru serta rekan sejawat) dilengkapi dengan data hasil belajar peserta didik, serta masukan orangtua/ wali. Rapor Pendidikan juga mulai digunakan data untuk refleksi dan evaluasi</li>',
        '<li>Sebagian guru menyesuaikan perencanaan pembelajaran berdasarkan hasil refleksi dan evaluasi tersebut.</li>',
        '</ul>',
      ].join(''),
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Refleksi dan evaluasi implementasi kurikulum dan pembelajaran dilakukan mayoritas atau semua guru. Hasil refleksi (pengalaman dan persepsi guru) dilengkapi dengan data Rapor Pendidikan</li>',
        '<li>Guru-guru dalam tim kecil (berdasarkan kelompok mata pelajaran dalam satu fase, guru kelas dalam satu fase, dan/ atau berbagai mata pelajaran dalam satu fase/ level) berdiskusi dan berkolaborasi untuk melakukan perencanaan pembelajaran berdasarkan hasil refleksi dan evaluasi.</li>',
        '<li>Satuan pendidikan telah memiliki kebijakan mengenai refleksi dan evaluasi kurikulum (contohnya melalui komunitas belajar, pertemuan rutin guru, kebijakan tentang penulisan rapor dan pemberian umpan balik kepada peserta didik).</li>',
        '</ul>',
      ].join(''),
    },
  ],
};
